import { base64Code } from "@/common/utils/index.js";
export default {
  data() {
    return {
      remember: false, // 是否记住我
    };
  },
  methods: {
    _remember_set() {
      // 记住账号密码
      if (this.remember) {
        const USERINFO = [
          base64Code(this.ruleForm.username, 0),
          base64Code(this.ruleForm.password, 0),
        ];
        // this.$Cookies.set(`${this.$project}USER`, JSON.stringify(USERINFO));
        window.localStorage.setItem(
          `${this.$project}USER`,
          JSON.stringify(USERINFO)
        );
      } else {
        // this.$Cookies.remove(`${this.$project}USER`);
        window.localStorage.removeItem(`${this.$project}USER`);
      }
    },
    _remember_get() {
      // 获取账号密码
      // if (this.$Cookies.get(`${this.$project}USER`)) {
      if (window.localStorage.getItem(`${this.$project}USER`)) {
        this.remember = true;
        // const USERINFO = JSON.parse(this.$Cookies.get(`${this.$project}USER`));
        const USERINFO = JSON.parse(
          window.localStorage.getItem(`${this.$project}USER`)
        );
        this.ruleForm.username = base64Code(USERINFO[0], 1);
        this.ruleForm.password = base64Code(USERINFO[1], 1);
        for (let i in this.ruleForm) this.initFormControl(i);
      }
    },
    handleRemember() {
      // 记住我

      this.remember = !this.remember;
    },

    initFormControl(i) {},
  },
};



// WEBPACK FOOTER //
// ./src/common/mixin/login/index.js